import { render, staticRenderFns } from "./FormDataDialog.vue?vue&type=template&id=771d0e9b"
import script from "./FormDataDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormDataDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports